import React, { useState, useEffect } from 'react';
import { Box, Grid, TextField } from '@mui/material';
import ImageUploader from './ImageUploader';
import { useTranslation } from 'react-i18next';

const EditSiteForm = ({ initialValues, onFormChange }) => {
    const { t } = useTranslation();

    const [formValues, setFormValues] = useState({
        planId: 'basic',
        coupleName: '',
        startDate: '',
        startTime: '',
        startDateTime: '',
        message: '',
        youTubeUrl: '',
        imageUrls: [],
        ...initialValues,
    });

    useEffect(() => {
        if (initialValues?.startDateTime) {
            const [date, time] = initialValues.startDateTime.split('T');
            initialValues.startDate = date;
            initialValues.startTime = time ? time.slice(0, 5) : '00:00';
        }

        setFormValues((prevValues) => ({ ...prevValues, ...initialValues }));
    }, [initialValues]);

    const handleInputChange = (field, value) => {
        let updatedValues = { ...formValues, [field]: value };

        if (field === 'startDate' || field === 'startTime') {
            const startDate = field === 'startDate' ? value : formValues.startDate;
            const startTime = field === 'startTime' ? value : formValues.startTime || '00:00';

            if (startDate) {
                const validStartTime = startTime.match(/^([01]\d|2[0-3]):([0-5]\d)$/) ? startTime : '00:00';
                updatedValues.startDateTime = `${startDate}T${validStartTime}:00`;
            } else {
                updatedValues.startDateTime = '';
            }
        }

        setFormValues(updatedValues);
        onFormChange && onFormChange(updatedValues);
    };

    const handleUploadComplete = (urls) => {
        const updatedValues = { ...formValues, imageUrls: urls };
        setFormValues(updatedValues);
        onFormChange && onFormChange(updatedValues);
    };

    return (
        <Box
            component="form"
            noValidate
            autoComplete="off"
            sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}
        >
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <TextField
                        fullWidth
                        label={t('create_form_start_date_label')}
                        type="date"
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                        value={formValues.startDate}
                        onChange={(e) => handleInputChange('startDate', e.target.value)}
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextField
                        fullWidth
                        label={t('create_form_start_time_label')}
                        type="time"
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                        value={formValues.startTime}
                        onChange={(e) => handleInputChange('startTime', e.target.value)}
                    />
                </Grid>
            </Grid>

            <TextField
                fullWidth
                label={t('create_form_message_label')}
                placeholder={t('create_form_message_placeholder')}
                variant="outlined"
                InputProps={{
                    rows: 8,
                    multiline: true,
                    inputComponent: 'textarea'
                }}
                InputLabelProps={{ shrink: true }}
                value={formValues.message}
                onChange={(e) => handleInputChange('message', e.target.value)}
            />

            {formValues.planId === 'premium' && (
                <TextField
                    fullWidth
                    label={t('create_form_youtube_label')}
                    placeholder="https://www.youtube.com/watch?v=PMivT7MJ41M"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    value={formValues.youTubeUrl}
                    onChange={(e) => handleInputChange('youTubeUrl', e.target.value)}
                />
            )}

            <ImageUploader
                autoUpload={true}
                buttonLabel={t(formValues.planId === 'premium' ? 'image_uploader_button_label_exclusive' : 'image_uploader_button_label_basic')}
                initialImageUrls={formValues.imageUrls}
                maxImages={formValues.planId === 'premium' ? 7 : 3}
                onUploadComplete={handleUploadComplete}
            />
        </Box>
    );
};

export default EditSiteForm;
